/** 标记行范围：由后端配置的 rowScope 枚举决定哪些行参与标记 */
export enum DashboardMarkRowScope {
    /** 全美 + 7 个主 HUB（分拣、断更看板） */
    NATION_AND_MAIN_HUBS = 'NATION_AND_MAIN_HUBS',
    /** 全美 + 所有 HUB + 所有 WHS + WHS 下展开的 DSP 行（尾程看板） */
    NATION_AND_ALL_HUB_WHS = 'NATION_AND_ALL_HUB_WHS',
}

/** 看板 common_config 的 configKey，与后端 DashboardMarkRuleParser.DEFAULT_MARK_RULES 的 key 一一对应 */
export const DASHBOARD_MARK_CONFIG_KEY = {
    SORTING: 'dashboard.mark.sorting',
    DELIVERY: 'dashboard.mark.delivery',
    NO_UPDATE: 'dashboard.mark.noUpdate',
} as const;

export interface DashboardMarkRule {
    /** 指标字段名，对应各看板的 metricType / 列字段名 */
    fieldName: string;
    /** 标记列相对今天（美西）的偏移天数，如 1 表示 T-1；同时是周环比红框的判定列 */
    columnOffset: number;
    /** 黄底区间的结束偏移天数（越大越旧），与 columnOffset 相等表示只标一列 */
    columnOffsetEnd: number;
    rowScope: DashboardMarkRowScope;
    /** 是否包含展开的下钻子行 */
    includeDrillDown: boolean;
    /** 目标值比较操作符 */
    targetOperator: '>' | '<';
    /** 目标值，展示值口径（如 0.1 表示 0.1%） */
    targetValue: number;
    /** 周环比比较操作符；为空表示该指标不做周环比标记（不标红框） */
    womOperator?: '>' | '<' | null;
    /** 周环比阈值(pp)；为空表示该指标不做周环比标记（不标红框） */
    womValue?: number | null;
}

export interface QueryDashboardMarkRulesResponse {
    queryDashboardMarkRules: DashboardMarkRule[];
}
